import { UtilComponent } from './../../../shared/common/utils/UtilComponent';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, catchError, delay, switchMap, tap, throwError } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserServiceHeader } from 'app/core/user/user.service';
import { AppState } from 'app/shared/common/utils/AppState';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AboutComponent } from './modal/about/about.component';
import { DmsService } from 'app/shared/common/utils/DmsService';
import { DomSanitizer } from '@angular/platform-browser';
import { PopUpUserTenant } from './popup-user-tenant/popup-user-tenant';
import { AppStateConstant } from 'app/shared/common/constants/AppState.constant';
import { untilDestroyed } from '@ngneat/until-destroy';
import { TenantService } from 'app/modules/manage/components/tenant/tenant.service';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
    public static ngAcceptInputType_showAvatar: BooleanInput;
    public currentUser: any;
    public isImage: boolean = false;
    public user: User;
    public image: any;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @Input() showAvatar: boolean = true;
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserServiceHeader,
        private _appState: AppState,
        private _matDialog: MatDialog,
        private _manageTenantService: TenantService,
        private _dmsService: DmsService,
        private _domSanitizer: DomSanitizer,
        private _utilComponent: UtilComponent,
    ) {
    }


    ngOnInit(): void {
        this._appState.getUserInfo().then(rs => {
            this.currentUser = rs
        })
    }


    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    signOut(): void {
        this._appState.clearLogout(true);
        this._router.navigate(['/sign-in']);
    }

    openAbout(): void {
        this._matDialog.open(
            AboutComponent, {
            autoFocus: false,
            panelClass: "remove-scroll",
            width: '300px',
            height: '300px'
        }
        );
    }

    openProfile(): void {
        this._router.navigate(['/settings/profile']);
    }

    downloadAvatarExport(identifier: string, fileName: string): void {
        this._dmsService.getMultiPartContent(identifier).then(blob => {
            if (!blob) {
                this._utilComponent.showTranslateSnackbar('SYSTEM_ERROR', 'error');
            } else {
                const urlCreator = window.URL || window['webkitURL'];
                const imageSrc = urlCreator.createObjectURL(blob);
                const img = this._domSanitizer.bypassSecurityTrustResourceUrl(imageSrc);
                this.image = img;
                this.isImage = true;
                this._changeDetectorRef.markForCheck();
            }
        }).catch(error => {
            // tslint:disable-next-line: no-console
            console.error('Error when download file: ${identifier}', error);
            this._utilComponent.showTranslateSnackbar('SYSTEM_ERROR', 'error');
        });
    }

    openChangeTenant(): void {
        const dialogRef = this._matDialog.open(PopUpUserTenant, {
            id: 'matPopUpUserTenant',
        });
        dialogRef.componentInstance.tenant = this.currentUser?.moreInfo.tenantCode;
        dialogRef?.componentInstance?.submitClicked?.pipe(
            untilDestroyed(dialogRef?.componentInstance),
            switchMap(rs => {
                return this._manageTenantService?.changeTenant({
                    username: this.currentUser?.username,
                    password: this.currentUser?.password,
                    tenantCode: rs
                });
            }),
            catchError(err => {
                this._utilComponent.showTranslateSnackbar('SYSTEM_ERROR', 'error');
                return throwError(() => {
                    return new Error(err);
                })
            }),
            tap((rs) => {
                this._utilComponent.showTranslateSnackbar('ACTION_SUCCESS', 'complete');
                localStorage.setItem(AppStateConstant.ServerToken, rs.id_token);
                this._appState.serverToken = rs?.id_token;
                dialogRef?.close();
            }),
            delay(1000),
        )?.subscribe(rs => {
            location.reload();
        })
        dialogRef.afterClosed().subscribe(result => {
        });
    }
}
